import config from "../../config";

export function getGcpRequestAsanaTaskLink(customerId: string, siteId: string) {
  const pattern = config.gcpRequestAsanaTaskUrlPattern;

  return pattern.replace("{customer}", customerId).replace("{site}", siteId);
}
